import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/fcdcc7c9-830c-42eb-b2c0-56a62fc1ea66.png"
              alt="VPB Logo"
              className="h-12 w-auto"
              loading="eager"
              fetchpriority="high"
              width="120"
              height="48"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('guia')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Guía
            </button>
            <button
              onClick={() => scrollToSection('costes')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Costes
            </button>
            <button
              onClick={() => scrollToSection('preparacion')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Preparación
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>

          <div className="md:hidden flex items-center gap-3">
            <a
              href="tel:629501941"
              className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Llamar
            </a>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`p-2 rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
              aria-label="Menú"
            >
              {isMenuOpen ? (
                <i className="ri-close-line text-2xl"></i>
              ) : (
                <i className="ri-menu-line text-2xl"></i>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className={`py-4 space-y-3 ${isScrolled ? 'bg-white' : 'bg-gray-900/95'}`}>
            <button
              onClick={() => scrollToSection('inicio')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('guia')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Guía
            </button>
            <button
              onClick={() => scrollToSection('costes')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Costes
            </button>
            <button
              onClick={() => scrollToSection('preparacion')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Preparación
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              Contacto
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}